module.exports = __webpack_public_path__ + "img/process4.211da2b6.png";